import { PlantLayoutEditorThemeSizeConfig } from './types';

const large: PlantLayoutEditorThemeSizeConfig = {
  plantLayoutEditor: {},
};

export default large;
